import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

export const SectionTwo = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // use an object instead of array to avoid index collisions
  const [flippedCards, setFlippedCards] = useState({});

  const toggleFlip = (key) => {
    setFlippedCards((prev) => ({
      ...prev,
      [key]: !prev[key], // toggle only this card
    }));
  };

  const renderCards = (cards, groupName) => (
    <div className="info-section-two-cc">
      <div className="card-wrapper-cc">
        {cards.map((card, idx) => {
          const key = `${groupName}-${idx}`;
          return (
            <div
              key={key}
              className={`info-card-two-cc ${flippedCards[key] ? "flipped" : ""}`}
              onClick={() => isMobile && toggleFlip(key)}
            >
              {/* Front side */}
              <div className="card-front-cc">
                <h2 className="heading-cc">{card.title}</h2>
                <p className="info-text-two-cc">{card.headline}</p>
              </div>

              {/* Back side */}
              <div className="card-back-cc">
                <p className="heading-cc-bg">{card.title}</p>
                <p className="hover-subtitle">{card.onhover.sub_title1}</p>
                <img
                  src="assets/images/checkout-v-one/arrow.png"
                  alt=""
                  className="info-icon1-cc"
                />
                <p className="hover-subtitle">{card.onhover.sub_title2}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const cardsData1 = [
    {
      title: "Dev Time",
      headline: "Months spent building custom checkout",
      onhover: { sub_title1: "Slower GTM", sub_title2: "Delayed revenue" },
    },
    {
      title: "High RTO",
      headline: "30% RTO on COD orders",
      onhover: { sub_title1: "Burnt logistics cost", sub_title2: "Ops overhead" },
    },
  ];

  const cardsData2 = [
    {
      title: "Multiple Tools",
      headline: "Stitched 4–5 tools for COD, fraud, RTO",
      onhover: { sub_title1: "Fragile stack", sub_title2: "More bugs, more breakage" },
    },
    {
      title: "Low Conversions",
      headline: "Broken checkout build losing customers",
      onhover: { sub_title1: "Rising CAC, Poor ROAS", sub_title2: "Missed revenue" },
    },
  ];

  const cardsData3 = [
    {
      title: "Checkout drop-offs",
      headline: "Poor UX on mobile & pay flows",
      onhover: { sub_title1: "Shoppers drop-off", sub_title2: "Lost conversions" },
    },
    {
      title: "Lower Prepaid",
      headline: "Shoppers avoid paying upfront",
      onhover: { sub_title1: "High COD risk exposure", sub_title2: "Delayed cash inflows" },
    },
  ];

  return (
    <div className="section-two-cc">
      <div className="container-fluid">
        <div
          className="mid-text3-sec-two-cc w-full md:w-6 mt-10"
          style={{ margin: isMobile ? "0px 0.2rem" : "0px 5rem" }}
        >
          <p style={{ color: "#fff" }}>Cut Costs, Not Corners</p>
          <h1>Custom Doesn't Need to be Complicated</h1>
        </div>

        <div
          className="flip-head-cc flex gap-5"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <div className="tech-bussiness-head">Tech</div>
          <div className="tech-bussiness-head">Business</div>
        </div>

        {renderCards(cardsData1, "group1")}
        {renderCards(cardsData2, "group2")}
        {renderCards(cardsData3, "group3")}
      </div>
    </div>
  );
};

export default SectionTwo;
